import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';
import { CheckBlockService } from '../../../check-block/check-block.service';
import { ICheckBlock } from '../../../check-block/interface/check-block.interface';
import { ISample } from '../../../samples/interface/sample.interface';
import { SamplesService } from '../../../samples/service/samples.service';
import { ICheckBlockRaisedUserNotification } from '../../notification.type';
import { NOTIFICATION_INPUT } from '../../notifications.type';
import { NotificationsService } from '../../notifications.service';

@Component({
  standalone: true,
  imports: [RouterModule, MatButtonModule],
  template: `
    <h3>Checkblock has new message</h3>

    @if (checkBlock && sample) {
      <a
        mat-stroked-button
        [routerLink]="['/tows', sample.towId, 'samples', sample._id]"
        [queryParams]="{ checkblock: checkBlock._id, taxon: checkBlock.taxonId }"
        queryParamsHandling="merge"
        (click)="notificationService.setStatus(notification._id, 'read')"
      >
        {{ sample.oldSampleId }}
      </a>

      <p>{{ checkBlock.messages.at(-1)?.message || 'No checkblock message available.' }}</p>
    } @else {
      <button mat-stroked-button disabled>
        Checkblock unavailable ({{ notification.metadata.checkBlockId }})
      </button>

      <p>Linked sample unavailable.</p>
    }
  `,
})
export class CheckBlockReplyNotificationComponent {
  checkBlock: ICheckBlock | null = null;
  sample: ISample | null = null;

  constructor(
    @Inject(NOTIFICATION_INPUT) readonly notification: ICheckBlockRaisedUserNotification,
    readonly notificationService: NotificationsService,
    checkBlocks: CheckBlockService,
    samples: SamplesService,
  ) {
    checkBlocks
      .get(this.notification.metadata.checkBlockId)
      .then((checkBlock) => {
        this.checkBlock = checkBlock;

        if (!checkBlock?.sampleId) {
          this.sample = null;
          return;
        }

        return samples
          .getOne('', checkBlock.sampleId)
          .then((sample) => {
            this.sample = sample || null;
          })
          .catch(() => {
            this.sample = null;
          });
      })
      .catch(() => {
        this.checkBlock = null;
        this.sample = null;
      });
  }
}
